import React from 'react';
import { ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { checklistsService } from '../../services';

export const ChecklistsFormPage: React.FC = () => {
  return (
    <ResourceFormPage
      title="Checklist"
      service={checklistsService}
      redirectPath="/admin/logistica/checklists"
      fields={[
        { name: 'veiculo', label: 'Veículo', type: 'select', required: true },
        { name: 'template', label: 'Template', type: 'select', required: true },
        { name: 'responsavel', label: 'Responsável', type: 'select' },
        { name: 'status', label: 'Status', type: 'select', options: [
          { value: 'PENDENTE', label: 'Pendente' },
          { value: 'CONCLUIDO', label: 'Concluído' },
          { value: 'APROVADO', label: 'Aprovado' },
          { value: 'REPROVADO', label: 'Reprovado' },
        ]},
        { name: 'data_execucao', label: 'Data de Execução', type: 'date' },
        { name: 'observacoes', label: 'Observações', type: 'textarea' },
      ]}
    />
  );
};
